import { Col, FormGroup, Row } from "reactstrap";
import { H5 } from "../../../../../AbstractElements";
import CommonFileUpload from "../../../../../Utils/CommonComponents/CommonFileUpload";
import { UploadProjectFile } from "../../../../../Utils/Constants";

export default function UploadFile() {
  return (
    <Row>
      <Col>
        <FormGroup>
          <H5 className="f-w-600 mb-2">{UploadProjectFile}</H5>
          <CommonFileUpload />
        </FormGroup>
      </Col>
    </Row>
  );
}
